// extracted by mini-css-extract-plugin
export default {"link":"NavbarLink_link__cQMgX","link_active":"NavbarLink_link_active__CYXuM"};